/**
 * All the tools are here
 */

import React, { useState } from "react";
// import PerfectScrollbar from "react-perfect-scrollbar";
import { func, string, bool, object } from "prop-types";
import { injectIntl } from "react-intl";
import FilterTiltShift from "@material-ui/icons/FilterTiltShift";
import ToolContainer from "components/ToolContainer";
import { AnnotationShape } from "icons";
import { selectTool, deselectTool } from "redux/tools/actions";
import {
  makeCurrTool,
  selectAutoIrisCircleLoading,
  selectIsDisableMultipleSelection,
  selectIsMoveMode,
} from "redux/tools/selectors";
import {
  selectIsIrisCirclesShown,
  selectAreIrisCentersShown,
} from "redux/canvas/selectors";
import { selectUserRole } from "redux/permission/selector";
import { selectCurrLabel } from "redux/points/selectors";
import { connect, useSelector } from "react-redux";
// import DrawerModal from "components/DrawerModal";
import BaseModal from "components/Modal";
import AutoLabels from "./AutoLabels";
import {
  Box,
  Point,
  Polygon,
  Polyline,
  Cuboid,
  ObjectTracking,
  FormatShapes,
  MoveIcon,
} from "icons";
import {
  selectImageId,
  selectImageAnnotationType,
  selectImageStatus,
} from "redux/image/selectors";
import { getDrawingSegmentations } from "redux/segmentation/selector";
import * as allTools from "redux/tools/enums";
import SegmentationToolButton from "components/SegmentationToolButton";
// import AutomaticAnnotationToolButton from "components/AutomaticAnnotationToolButton";
import style from "./style.module.scss";
import { getParameterByName } from "helpers";
import { selectCanPermissionEditAndLabelingTab } from "redux/app/selectors";
import { LABEL_SOURCE_STATUSES } from "helpers/constants";

// URL params are constant throughout the app's lifecycle — compute once at module load
const alterUserId = getParameterByName("alterUserId");
const isViewResult = getParameterByName("isViewResult");
const isActionHistory = getParameterByName("isActionHistory");
const disableOtherTools = isActionHistory || isViewResult;
const hideUnusedTool = false;

function ToolBar({
  imageStatus,
  selectTool,
  currTool,
  deselectTool,
  irisCircleLoading,
  isIrisCirclesShown,
  areIrisPointsSelected,
  currLabel,
  currImageId,
  drawingSegmentation,
  annotationType,
  isMoveMode,
  roleCode,
  reporterTab,
}) {
  const [isOpenDrawerAutoLabels, setIsOpenDrawerAutoLabels] = useState(false);
  const permissionEdit = useSelector(
    selectCanPermissionEditAndLabelingTab(imageStatus)
  );
  const enableEditting = !(
    alterUserId ||
    isViewResult ||
    !permissionEdit ||
    roleCode === "viewer"
  );

  const enabledAutoAnnotationTool =
    roleCode === "admin" ||
    (enableEditting &&
      [LABEL_SOURCE_STATUSES.NEW, LABEL_SOURCE_STATUSES.ASSIGNED].includes(
        imageStatus
      ));

  function handlePickTool(event) {
    const toolName = event.target.getAttribute("name");
    const disabledClass = event.target.getAttribute("data-disabled");
    if (disabledClass === `true`) {
      return;
    }
    if (currTool === toolName) {
      deselectTool();
      return;
    }
    if (!enableEditting && toolName !== allTools.MOVE_MODE) {
      return;
    }

    selectTool(toolName);
  }

  const checkDisableTool = (type) => {
    if (annotationType && annotationType.includes("ocr")) return true;
    return (
      !(
        currLabel &&
        currLabel.tools &&
        currLabel.tools.includes(`${type}-image`)
      ) ||
      !currImageId ||
      drawingSegmentation
    );
  };

  return (
    <div
      className={style.toolBarContainer}
      style={{
        width: reporterTab === "labeling" ? "48px" : "0px",
      }}
    >
      <div className={style.box}>
        <ToolContainer
          currTool={isMoveMode ? allTools.MOVE_MODE : ""}
          onClick={handlePickTool}
          tooltipText="Move the image (1)"
          name={allTools.MOVE_MODE}
        >
          <MoveIcon style={{ pointerEvents: "none" }} />
        </ToolContainer>
        <ToolContainer
          currTool={currTool}
          name={allTools.BOX_MODE}
          onClick={handlePickTool}
          disabledClass={!enableEditting || checkDisableTool(allTools.BOX_MODE)}
          tooltipText="Bounding box (3)"
        >
          <Box style={{ pointerEvents: "none" }} />
        </ToolContainer>

        <ToolContainer
          currTool={currTool}
          disabledClass={
            !enableEditting ||
            checkDisableTool(allTools.POLYGON_MODE) ||
            disableOtherTools
          }
          name={allTools.POLYGON_MODE}
          tooltipText="Polygonal segmentation (4)"
          onClick={handlePickTool}
        >
          <Polygon style={{ pointerEvents: "none" }} />
        </ToolContainer>

        {/* <AutomaticAnnotationToolButton
          checkDisableTool={false}
          name={allTools.AUTOMATIC_ANNOTATION_MODE}
          handlePickTool={handlePickTool}
          disabledClass={!enableEditting}
        /> */}
        <ToolContainer
          currTool={currTool}
          disabledClass={!enabledAutoAnnotationTool}
          name={allTools.AUTOMATIC_ANNOTATION_MODE}
          tooltipText="Auto Labels"
          onClick={() => setIsOpenDrawerAutoLabels(true)}
        >
          <AnnotationShape style={{ pointerEvents: "none" }} />
        </ToolContainer>

        {!hideUnusedTool && (
          <>
            <ToolContainer
              currTool={currTool}
              name={allTools.AUTO_IRIS_MODE}
              onClick={handlePickTool}
              loading={irisCircleLoading}
              disabledClass={
                !isIrisCirclesShown ||
                areIrisPointsSelected ||
                disableOtherTools
              }
              tooltipText="Auto position iris circles (2)"
            >
              <FilterTiltShift className={style.disablePointerEvent} />
            </ToolContainer>
            <ToolContainer
              currTool={currTool}
              name={allTools.LANDMARK_POINT_MODE}
              disabledClass
              tooltipText="Landmark point"
            >
              <Point style={{ pointerEvents: "none" }} />
            </ToolContainer>
            <ToolContainer
              currTool={currTool}
              name={allTools.POLYLINE_MODE}
              disabledClass={
                checkDisableTool(allTools.POLYLINE_MODE) || disableOtherTools
              }
              tooltipText="Polyline (8)"
              onClick={handlePickTool}
            >
              <Polyline style={{ pointerEvents: "none" }} />
            </ToolContainer>
            <ToolContainer
              currTool={currTool}
              name={allTools.CUBOID_MODE}
              disabledClass={
                checkDisableTool(allTools.CUBOID_MODE) || disableOtherTools
              }
              tooltipText="Cuboid (6)"
              onClick={handlePickTool}
            >
              <Cuboid style={{ pointerEvents: "none" }} />
            </ToolContainer>
            <SegmentationToolButton
              checkDisableTool={checkDisableTool}
              name={allTools.SEGMENTATION_MODE}
              handlePickTool={handlePickTool}
              disabledClass={disableOtherTools}
            />
            <ToolContainer
              currTool={currTool}
              name={allTools.OBJECT_TRACKING_MODE}
              disabledClass
              arrow
              tooltipText="Smart tool object tracking"
            >
              <ObjectTracking style={{ pointerEvents: "none" }} />
            </ToolContainer>
            <ToolContainer
              currTool={currTool}
              name={allTools.OCR}
              disabledClass={
                !(
                  annotationType &&
                  annotationType.includes("ocr") &&
                  currLabel
                ) || disableOtherTools
              }
              tooltipText="Text box"
              onClick={handlePickTool}
            >
              <FormatShapes style={{ pointerEvents: "none" }} />
            </ToolContainer>
          </>
        )}
      </div>
      {isOpenDrawerAutoLabels && (
        <BaseModal
          title="Auto Labels"
          isOpen={isOpenDrawerAutoLabels}
          content={<AutoLabels setOpen={setIsOpenDrawerAutoLabels} />}
          setIsOpen={setIsOpenDrawerAutoLabels}
          hide
        />
      )}
    </div>
  );
}

ToolBar.propTypes = {
  imageStatus: string,
  selectTool: func,
  currTool: string,
  deselectTool: func,
  irisCircleLoading: bool,
  isIrisCirclesShown: bool,
  areIrisPointsSelected: bool,
  currLabel: object,
  isDisableMultipleSelection: bool,
  currImageId: string,
  drawingSegmentation: object,
  annotationType: string,
  isMoveMode: bool,
  roleCode: string,
  reporterTab: string,
};

const mapStateToProps = () => (state) => {
  return {
    imageStatus: selectImageStatus(state),
    currTool: makeCurrTool(state),
    irisCircleLoading: selectAutoIrisCircleLoading(state),
    isIrisCirclesShown: selectIsIrisCirclesShown(state),
    areIrisPointsSelected: selectAreIrisCentersShown(state),
    currLabel: selectCurrLabel(state),
    isDisableMultipleSelection: selectIsDisableMultipleSelection(state),
    currImageId: selectImageId(state),
    drawingSegmentation: getDrawingSegmentations(state),
    annotationType: selectImageAnnotationType(state),
    isMoveMode: selectIsMoveMode(state),
    roleCode: selectUserRole(state),
  };
};

export default connect(mapStateToProps, {
  selectTool,
  deselectTool,
})(injectIntl(ToolBar));
